var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.04 2C6.545 2 2 6.468 2 11.96C2 17.455 6.546 22 12.04 22C17.531 22 22 17.454 22 11.96C22 6.469 17.532 2 12.04 2ZM13.21 17.313C13.21 17.959 12.685 18.484 12.04 18.484C11.7291 18.484 11.4309 18.3606 11.2109 18.1408C10.991 17.921 10.8673 17.6229 10.867 17.312V11.375C10.867 10.729 11.393 10.203 12.039 10.203C12.685 10.203 13.211 10.729 13.211 11.375V17.313H13.21ZM12.04 7.859C11.7292 7.859 11.4312 7.73569 11.2113 7.51614C10.9913 7.2966 10.8675 6.99875 10.867 6.688C10.867 6.041 11.393 5.516 12.039 5.516C12.685 5.516 13.211 6.041 13.211 6.687C13.211 7.334 12.685 7.859 12.039 7.859H12.04Z",
    fill: "#3889FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.2984b8d7.svg";
export { ForwardRef as ReactComponent };